import { useState, useEffect } from 'react';
import { getQuestionnaireDetails } from '../services/questionnaireService';

const useQuestionnaire = (id) => {
  const [questionnaire, setQuestionnaire] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchQuestionnaire = async () => {
      try {
        const data = await getQuestionnaireDetails(id);
        setQuestionnaire(data);
      } catch (error) {
        setError('Failed to load questionnaire details. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchQuestionnaire();
    }
  }, [id]);

  return { questionnaire, loading, error };
};

export default useQuestionnaire;
